(function () {
  'use strict';

  function Dialog(opts) {
    opts = opts || {};

    let defaults = {
      type: 'confirm', // 'confirm' or 'message'
      title: '',
      message: null,
      messageHtml: null,
      cancel: 'Cancel',
      confirm: 'Confirm',
      onClose: function () {},
      onCancel: function () {},
      onConfirm: function () {},
      closable: false,
      closeLabel: 'Close dialog',
      clickedElement: null,
    };

    opts = util.deepExtend(defaults, opts);

    const body = document.querySelector('body');

    // Create overlay
    const dialog = document.createElement('div');
    dialog.classList.add('dialog');
    dialog.setAttribute('tabindex', 0);
    dialog.setAttribute('role', 'dialog');

    // Create close button
    if (opts.closable) {
      const closeButton = document.createElement('a');
      closeButton.classList.add('dialog__close');
      closeButton.setAttribute('aria-label', opts.closeLabel);
      closeButton.href = '#';
      closeButton.innerHTML =
        '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="currentColor" d="M446.627 110.627l-45.254-45.254-145.373 145.372-145.373-145.372-45.254 45.253 145.373 145.374-145.373 145.373 45.254 45.254 145.373-145.373 145.373 145.373 45.254-45.255-145.372-145.372z"></path></svg>';

      // Create close event
      var closeEvent = new CustomEvent('dialogClose', {
        bubbles: true,
        cancelable: true,
        detail: {},
      });

      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        opts.onClose();
        dialog.dispatchEvent(closeEvent);
        close();
      });

      dialog.appendChild(closeButton);
    }

    // Create message
    const box = document.createElement('div');
    box.classList.add('dialog__box');

    const message = document.createElement('div');
    message.classList.add('dialog__message');
    message.classList.add('is-content');

    if (opts.title !== '') {
      message.innerHTML += '<h3 class="is-h3">' + opts.title + '</h3>';
    }
    if (opts.message !== null) {
      message.innerHTML += '<p>' + opts.message + '</p>';
    }
    if (opts.messageHtml !== null) {
      message.innerHTML += opts.messageHtml;
    }

    // Create buttons
    const buttons = document.createElement('div');
    buttons.classList.add('dialog__buttons');

    if (opts.type === 'confirm') {
      const cancelButton = document.createElement('a');
      cancelButton.href = '#';
      cancelButton.classList.add('button');
      cancelButton.classList.add('button--light');
      cancelButton.classList.add('dialog__cancel');
      cancelButton.innerHTML = opts.cancel;

      // Create cancel event
      var cancelEvent = new CustomEvent('dialogCancel', {
        bubbles: true,
        cancelable: true,
        detail: {},
      });

      cancelButton.addEventListener('click', (e) => {
        e.preventDefault();
        opts.onCancel();
        dialog.dispatchEvent(cancelEvent);
        close();
      });

      buttons.appendChild(cancelButton);
    }

    const confirmButton = document.createElement('a');
    confirmButton.href = '#';
    confirmButton.classList.add('button');
    confirmButton.classList.add('dialog__confirm');
    confirmButton.innerHTML = opts.confirm;

    // Create confirm event
    var confirmEvent = new CustomEvent('dialogConfirm', {
      bubbles: true,
      cancelable: true,
      detail: {},
    });

    confirmButton.addEventListener('click', (e) => {
      e.preventDefault();
      opts.onConfirm();
      dialog.dispatchEvent(confirmEvent);
      close();
    });

    buttons.appendChild(confirmButton);

    // Combine all elements
    box.appendChild(message);
    box.appendChild(buttons);
    dialog.appendChild(box);

    // Add dialog to DOM
    body.appendChild(dialog);
    body.classList.add('dialog__container');

    // Set focus on buttons
    dialog.focus();

    function close() {
      body.removeChild(dialog);
      body.classList.remove('dialog__container');

      // switch focus back to clicked element
      if (opts.clickedElement != null) {
        opts.clickedElement.focus({ preventScroll: true });
      }
    }

    function addEventListener(eventName, event) {
      dialog.addEventListener(eventName, event);
    }

    return {
      close: close,
      addEventListener: addEventListener,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Dialog;
  } else {
    window.Dialog = Dialog;
  }
})();
